module.exports = __webpack_public_path__ + "img/umbrides_cat_plates.20784b03.jpg";